__turbopack_context__.v({
  "baseButton": "SortResults-module-scss-module__v1U9sq__baseButton",
  "disabled": "SortResults-module-scss-module__v1U9sq__disabled",
  "iconButton": "SortResults-module-scss-module__v1U9sq__iconButton",
  "primary": "SortResults-module-scss-module__v1U9sq__primary" + " " + "SortResults-module-scss-module__v1U9sq__baseButton",
  "secondary": "SortResults-module-scss-module__v1U9sq__secondary" + " " + "SortResults-module-scss-module__v1U9sq__baseButton",
  "small": "SortResults-module-scss-module__v1U9sq__small",
  "sortByHeader": "SortResults-module-scss-module__v1U9sq__sortByHeader",
  "sortBySelect": "SortResults-module-scss-module__v1U9sq__sortBySelect" + " " + "SortResults-module-scss-module__v1U9sq__baseButton",
  "tertiary": "SortResults-module-scss-module__v1U9sq__tertiary" + " " + "SortResults-module-scss-module__v1U9sq__baseButton",
  "unstyled": "SortResults-module-scss-module__v1U9sq__unstyled",
});
